// extracted by mini-css-extract-plugin
export default {"flex":"styles_flex__o0lKg"};